import dayjs from '../../utils/dayjs';
import { DataTable, EmptyState, Layout, Page, Card, Text, Thumbnail, Link, InlineStack } from '@shopify/polaris';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { LockIcon, EditIcon } from '@shopify/polaris-icons';
import emptyIMG from '../../media/images/empty.png';
import Pagination from '../../components/pagination';
import helpers from '../../helpers';
import SkeletonLoading from 'components/skeletonPageLoading';
import __, { ___ } from 'languages/index';
import { Helmet } from 'react-helmet-async';
import { TypedPosts, useGetPosts } from 'queries/posts.query';

export default function PagesList() {
  // const entity = useAppSelector(state => state.posts.entity);

  const navigate = useNavigate();
  const [entities, setEntities] = useState<TypedPosts[]>(null);
  const [totalItems, setTotalItems] = useState<number>(0);

  /**
   * If user apply filter, it will add to URL, then parse URL back to initial state
   */
  let { search } = useLocation();
  let StringQuery: any = helpers.ExtractUrl(search) || false;

  const initialQuery = {
    query: '',
    page: 1,
    limit: 20,
    post_type: 'page',
    sort: 'createdAt:desc',
  };
  const [mainQuery, setMainQuery] = useState({ ...initialQuery, ...StringQuery });

  const { data: allPosts, isLoading: loading, refetch: getEntities } = useGetPosts(mainQuery);

  /**
   * Change page number
   */
  const onChangePagination = useCallback((numPage: number, limit: number) => {
    setMainQuery((prevMainQuery) => ({ ...prevMainQuery, page: numPage, limit: limit }));
  }, []);

  useEffect(() => {
    let buildURLSearch = helpers.buildEndUrl(mainQuery);
    if (search !== buildURLSearch) navigate('/pages' + buildURLSearch);
    getEntities();
  }, [mainQuery]);

  useEffect(() => {
    if (!allPosts) return;
    let { body, totalItems } = allPosts;
    setEntities(body);
    setTotalItems(totalItems);
  }, [allPosts]);

  const emptyData = (
    <EmptyState heading="Không có trang!" image={emptyIMG}>
      <p>Oh, Không có gì ở đây. Hãy thử bỏ bộ lọc hoặc tạo mới.</p>
    </EmptyState>
  );

  const renderItem = (posts: TypedPosts) => {
    const { post_id, post_title, post_name, post_status, post_thumbnail_to_media, createdAt, updatedAt } = posts;
    return [
      post_id,
      <InlineStack gap="400" align="start" blockAlign="center">
        <Thumbnail
          alt={''}
          size="small"
          source={helpers.getMediaLink(
            post_thumbnail_to_media?.media_thumbnail ? post_thumbnail_to_media?.media_thumbnail['128x128'] : post_thumbnail_to_media?.media_url
          )}
        />
        <Link url={'/pages/edit/' + post_id}>
          <Text as="span">{post_title ? helpers.trimMiddleString(post_title, 15, 10) : 'Chưa có tiêu đề'}</Text>
        </Link>
      </InlineStack>,
      <p>
        <span className="small-icon">{post_status === 'publish' ? '' : <LockIcon />}</span> {__(`post_status_${post_status}`)}
      </p>,
      'AHA',
      dayjs(new Date(Number(createdAt))).format('HH:mm:ss DD-MM-YYYY'),
      updatedAt ? dayjs(new Date(Number(updatedAt))).format('HH:mm:ss DD-MM-YYYY') : '-',
    ];
  };
  const PagesList =
    totalItems > 0 ? (
      <>
        <DataTable
          verticalAlign={'middle'}
          columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text']}
          headings={['ID', 'Tiêu đề', 'Trạng thái', 'Tác giả', 'Thời gian tạo', 'Cập nhật gần nhất']}
          rows={entities?.map(renderItem)}
          hideScrollIndicator
          footerContent={___('Show page {display_page_number} of {total_record_number} results', {
            display_page_number: <Text as="strong">{mainQuery?.page || 1}</Text>,
            total_record_number: <Text as="strong">{totalItems}</Text>,
          })}
        />
      </>
    ) : (
      emptyData
    );

  const Actual_page = (
    <Page
      title="Trang"
      subtitle="Quản lý trang"
      primaryAction={{
        content: 'Tạo trang',
        disabled: false,
        icon: EditIcon,
        onAction: () => {
          navigate('/pages/new');
        },
      }}
    >
      <Layout>
        <Layout.Section>
          <Card padding="0">{PagesList}</Card>
          <br />
          {totalItems > mainQuery.limit ? (
            <Pagination TotalRecord={totalItems} activeCurrentPage={mainQuery.page} pageSize={mainQuery.limit} onChange={onChangePagination} />
          ) : null}
        </Layout.Section>
      </Layout>
    </Page>
  );

  return (
    <>
      <Helmet>
        <title>Danh sách trang</title>
      </Helmet>
      {entities === null ? <SkeletonLoading fullWidth /> : Actual_page}
    </>
  );
}
